const config = {
	basename: '',
	defaultPath: '/demographics',
	defaultHomePath: '/library/all',
	fontFamily: `'Roboto', sans-serif`,
	borderRadius: 12
};

export default config;
